import axios from "../plugins/parseAxios";

export class EmployeeApi {
  static createEmployee(formData) {
    return axios.post("functions/createEmployee", formData);
  }
  static removeEmployee(id) {
    return axios.post("functions/removeEmployee", {
      id
    });
  }
  static getEmployeeByProject(projectId) {
    return axios.post("functions/getEmployeeByProject", {
      projectId
    });
  }
  static updateEmployee(formData) {
    return axios.post("functions/updateEmployee", formData);
  }
}